import React, { useState } from 'react';
import { Auth } from 'aws-amplify';

import PasswordRules from '../passwordRules';
import { Col, Container, Form, Row } from 'react-bootstrap';

import { Button } from '../../../components';
import '../styles.scoped.css';

const NewPassword = ({ nextStep, setRequiredAttributes, userData }) => {
  const [error, setErrorMessage] = useState('');
  const [passwordCharCount, setPasswordCharCount] = useState(0);
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [invalidPassword, setInvalidPassword] = useState(false);

  const newPassword = payload => {
    Auth.completeNewPassword(payload?.user, payload?.password).catch(e => {
      console.log('e', e);
      if (e.code === 'UserLambdaValidationException') {
        signIn(payload);
      }
      if (e.code === 'LimitExceededException') {
        setErrorMessage(e.code);
      }
      if (e.code === 'NotAuthorizedException') {
        setErrorMessage(e.code);
      }
    });
  };

  const signIn = payload => {
    Auth.configure({ authenticationFlowType: 'CUSTOM_AUTH' });
    Auth.signIn(payload?.username, payload?.password)
      .then(user => {
        if (user.challengeName === 'CUSTOM_CHALLENGE') {
          if (user.challengeParam.customMfaChallenge === 'PICK_MFA_FACTOR') {
            setRequiredAttributes(JSON.parse(user.challengeParam.publicChallengeParameters));
            nextStep({
              ...userData,
              code: '',
              nextStep: 'MFACode',
              password: payload?.password,
              user: user,
              username: payload?.username,
              verifyCode: '',
            });
          }
        }
      })
      .catch(e => {
        console.log('e: ', e);
      });
  };

  return (
    <>
      {error === 'NotAuthorizedException' ? (
        <Row>
          <Col xs={12} className="d-flex justify-content-center mt-5 w-25">
            <p className="border border-danger m-2 p-1 text-center text-danger">Invalid user, please try again.</p>
          </Col>
          <Col xs={12} className="d-flex align-items-center justify-content-center">
            <Button
              onPress={() => {
                window.location.reload();
              }}
              variant="primary"
              text="Try Again"
            />
          </Col>
        </Row>
      ) : (
        <Container>
          <div className="password-border">
            <img style={{ width: '370px', marginBottom: '35px' }} src={require('../../../assets/login-logo.png')} />
            <div className="pt-3" style={{ width: '358px' }}>
              <Form.Group>
                {error === 'LimitExceededException' && (
                  <p className="border border-danger p-2 text-danger">
                    Attempt limit exceeded, please try after some time.
                  </p>
                )}
                <Form.Label>
                  <div className="mb-2">
                    Please enter your new password below.
                    <br />
                  </div>
                </Form.Label>
                <Form.Group>
                  <Form.Label>
                    <strong>New Password</strong>
                  </Form.Label>
                  <Form.Control
                    as="input"
                    name="password"
                    defaultValue={userData?.password}
                    placeholder=""
                    type="password"
                    onChange={event => {
                      setPasswordCharCount(event.target.value.length);
                      event.target.value === userData?.newPassword ? setPasswordMatch(true) : setPasswordMatch(false);
                      nextStep({
                        ...userData,
                        password: event.target.value,
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    <strong>Enter New Password Again</strong>
                  </Form.Label>
                  <Form.Control
                    as="input"
                    name="newPassword"
                    defaultValue={userData?.newPassword}
                    placeholder=""
                    type="password"
                    onChange={event => {
                      event.target.value === userData?.password ? setPasswordMatch(true) : setPasswordMatch(false);
                      setPasswordCharCount(event.target.value.length);
                      nextStep({
                        ...userData,
                        newPassword: event.target.value,
                      });
                    }}
                  />
                </Form.Group>
                {passwordCharCount > 0 && (
                  <PasswordRules
                    password={userData?.password}
                    newPassword={userData?.newPassword}
                    passwordCharCount={passwordCharCount}
                    passwordMatch={passwordMatch}
                    setInvalidPassword={setInvalidPassword}
                  />
                )}
                <Button
                  disabled={!invalidPassword}
                  fullWidth
                  style={{ marginTop: '0.5rem' }}
                  variant="secondary"
                  onPress={() => {
                    newPassword(userData);
                  }}
                  text="Send"
                />
              </Form.Group>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

export default NewPassword;
